import { render, staticRenderFns } from "./BannerLogo.vue?vue&type=template&id=051c9310&scoped=true&"
import script from "./BannerLogo.vue?vue&type=script&lang=js&"
export * from "./BannerLogo.vue?vue&type=script&lang=js&"
import style0 from "./BannerLogo.vue?vue&type=style&index=0&id=051c9310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051c9310",
  null
  
)

export default component.exports